module.exports = __webpack_public_path__ + "img/vold_Jazz_and_poetry.86697ab7.jpg";